type MediaKey =
  | 'xsmall'
  | 'small'
  | 'medium'
  | 'large'
  | 'xlarge'
  | 'xxlarge'
  | 'xxxlarge'
  | 'maxLarge'
type MediaSizeMap = Map<MediaKey, { min?: number; max?: number }>

class Media {
  static xsmall: MediaKey = 'xsmall'
  static small: MediaKey = 'small'
  static medium: MediaKey = 'medium'
  static large: MediaKey = 'large'
  static xlarge: MediaKey = 'xlarge'
  static xxlarge: MediaKey = 'xxlarge'
  static xxxlarge: MediaKey = 'xxxlarge'
  static maxLarge: MediaKey = 'maxLarge'
  static sizeMap: MediaSizeMap = new Map([
    [this.xsmall, { min: 0, max: 599 }],
    [this.small, { min: 600, max: 779 }],
    [this.medium, { min: 780, max: 979 }],
    [this.large, { min: 980, max: 1279 }],
    [this.xlarge, { min: 1280, max: 1339 }],
    [this.xxlarge, { min: 1440, max: 1560 }],
    [this.xxxlarge, { min: 1740, max: 1840 }],
    [this.maxLarge, { min: 2000, max: 2560 }],
  ])
  static between(smallKey: MediaKey, largeKey: MediaKey) {
    if (!this.sizeMap.has(smallKey) || !this.sizeMap.has(largeKey)) {
      throw new Error('Media does not have these sizes')
    }
    const smallSize = this.sizeMap.get(smallKey)!.min
    const largeSize = this.sizeMap.get(largeKey)!.max
    return `@media (min-width: ${smallSize}px) and (max-width: ${largeSize}px)`
  }
  static greaterThan(key: MediaKey) {
    if (!this.sizeMap.has(key)) {
      throw new Error('Media does not have this size')
    }
    return `@media (min-width: ${this.sizeMap.get(key)!.min}px)`
  }
  static lessThan(key: MediaKey) {
    if (!this.sizeMap.has(key)) {
      throw new Error('Media does not have this size')
    }
    return `@media (max-width: ${this.sizeMap.get(key)!.min! - 1}px)`
  }
  static size(key: MediaKey) {
    if (!this.sizeMap.has(key)) {
      throw new Error('Media does not have this size')
    }
    return this.between(key, key)
  }
}

export default Media
